document.querySelectorAll('.body-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      // show the product info for the selected body
      const bundleCards = Array.from(document.querySelectorAll(
        `.bundle-card[data-bundle-name="${btn.getAttribute('data-bundle-name')}"]`
      ));

      const selector = `.bundle-card[data-bundle-name="${btn.getAttribute(
        'data-bundle-name'
      )}"][data-collection-body="${btn.getAttribute('data-collection-body')}"]`;
      const activeCards = document.querySelectorAll(selector);

      bundleCards.forEach(function (form) {

        const activeBtns = Array.from(activeCards).reduce(
          (acc, curr) =>
            acc.concat(
              curr.querySelector(`.body-btn[data-collection-body="${btn.getAttribute('data-collection-body')}"]`)
            ),
          []
        );
        const sizeBtns = form.querySelectorAll('.body-btn');
        sizeBtns.forEach((btn) => btn.classList.remove('active-body'));

        const order = Array.from(bundleCards)
          .map((card) => card.getAttribute('data-card-index'))
          ?.filter(Boolean)?.[0];

        Array.from(activeBtns).forEach((btnItem) => {
          btnItem.classList?.add('active-body');
        });

        if (form.getAttribute('data-collection-body') === btn.getAttribute('data-collection-body')) {
          form.style.visibility = 'visible';
          form.style.height = 'max-content';
          form.style.width = '45%';
          form.style.padding = '40px 24px';
          form.style.position = 'relative';
          form.style.zIndex = '1';
          form.style.order = order;
        } else {
          form.style.visibility = 'hidden';
          form.style.height = '0px';
          form.style.width = '0px';
          form.style.padding = '0px';
          form.style.position = 'absolute';
          form.style.zIndex = '-1';
        }
      });

      // click the selected variants (size and colors) of the selected body
      const selectesSizeIndex = bundleCards.filter(card=>card.style.display === 'none').map( (card) => card.querySelector(".size-btn.active-size")?.getAttribute('data-size-index') ).filter(Boolean)[0];
      const sizeVariant = Array.from(activeCards[0].querySelectorAll('.size-btn'))[selectesSizeIndex];

      if (sizeVariant) sizeVariant.click();
    });
  });